import { usePopularServiceState } from '@kc-console/context';

import type { PopularService } from '@kc-console/context';
/** 주석 작성
 * ~~~을 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * @description
 * -
 */
interface RefinedPopularServiceStateProps {
  popularServices: PopularService[];
}

export const useRefinedPopularServiceState = (): RefinedPopularServiceStateProps => {
  const { data = [] } = usePopularServiceState();

  return {
    popularServices: data,
  };
};
